<template>
  <div class="card">
    <div v-if="cargando">
      <div class="d-flex justify-content-center">
        <div class="spinner-border m-5" role="status">
          <span class="sr-only">Loading...</span>
        </div>
      </div>
    </div>
    <div v-else-if="opcion == 'encuesta'">
      <div class="card-body pt-0 px-2" v-for="encuesta of encuestas">
        <div class="row bg-danger pb-1 pt-2">
          <div class="col-12 text-white">
            <h5>{{ encuesta.encuesta }}</h5>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-12 pl-3 pr-1">
            <h5>{{ encuesta.pregunta }}</h5>
          </div>
          <div class="form-check col-12 pl-5">
            <input
              class="form-check-input"
              type="radio"
              v-model="encuesta.selected"
              name="encuesta_dashboard"
              id="respuesta1"
              value="respuesta1"
            />
            <label class="form-check-label" for="respuesta1">
              <h4>
                <small>
                  {{ encuesta.respuesta1 }}
                </small>
              </h4>
            </label>
          </div>
          <div class="form-check col-12 pl-5">
            <input
              class="form-check-input"
              type="radio"
              v-model="encuesta.selected"
              name="encuesta_dashboard"
              id="respuesta2"
              value="respuesta2"
            />
            <label class="form-check-label" for="respuesta2">
              <h4>
                <small>
                  {{ encuesta.respuesta2 }}
                </small>
              </h4>
            </label>
          </div>
          <div class="form-check col-12 pl-5">
            <input
              class="form-check-input"
              type="radio"
              v-model="encuesta.selected"
              name="encuesta_dashboard"
              id="respuesta3"
              value="respuesta3"
            />
            <label class="form-check-label" for="respuesta3">
              <h4>
                <small>
                  {{ encuesta.respuesta3 }}
                </small>
              </h4>
            </label>
          </div>
          <div class="form-check col-12 pl-5">
            <input
              class="form-check-input"
              type="radio"
              v-model="encuesta.selected"
              name="encuesta_dashboard"
              id="respuesta4"
              value="respuesta4"
            />
            <label class="form-check-label" for="respuesta4">
              <h4>
                <small>
                  {{ encuesta.respuesta4 }}
                </small>
              </h4>
            </label>
          </div>
        </div>
        <div class="row mt-3" v-if="listo">
          <div class="col-12 text-center">
            <button class="btn btn_blue" v-on:click="Enviar_Respuesta">
              Enviar Respuesta
            </button>
          </div>
        </div>
      </div>
    </div>
    <div
      class="card-body pt-0 px-2"
      v-else-if="opcion == 'graficas'"
      v-for="encuesta of encuestas"
    >
      <div class="row bg-danger pb-1 pt-2">
        <div class="col-12 text-white">
          <h5>
            {{ encuesta.encuesta }}
          </h5>
        </div>
      </div>
      <div class="row mt-3 mb-0">
        <div class="col-12">
          <h6 class="mb-0">{{ encuesta.pregunta }}</h6>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div id="grafica_encuesta" style="height: 300px; width: 100%" v-if="usuario.usuario_sistema != 'Contratista'"></div>
          <div style="width: 100%" v-else>Gracias por su participación!</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      cargando: true,
      opcion: "encuesta",
      encuestas: [],
      encuesta_contestada: false,
      grafica: [],
    };
  },
  methods: {
    Enviar_Respuesta() {
      this.cargando = true;
      this.$http
        .post("dashboard/encuestas", {
          encuestas: this.encuestas,
        })
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          if (respuestaJson.resp == "Excelente") {
            this.opcion = "graficas";
            this.Consultar();
          } else {
            this.cargando = false;
            swal("Ups", respuestaJson.resp, "error");
          }
        })
        .catch((error) => {
          this.cargando = false;
          swal("Ups", "Problemas para enviar la encuesta", "error");
        });
    },
    Mostrar_Grafica() {
      var that = this;
      var myChart = echarts.init(document.getElementById("grafica_encuesta"));
      var datos = [];
      var respuestas = [];
      for (var i = 0; i < this.encuestas.length; i++) {
        datos.push(this.encuestas[i].respuesta1_cantidad);
        datos.push(this.encuestas[i].respuesta2_cantidad);
        datos.push(this.encuestas[i].respuesta3_cantidad);
        datos.push(this.encuestas[i].respuesta4_cantidad);
        respuestas.push(this.encuestas[i].respuesta1);
        respuestas.push(this.encuestas[i].respuesta2);
        respuestas.push(this.encuestas[i].respuesta3);
        respuestas.push(this.encuestas[i].respuesta4);
      }
      // specify chart configuration item and data
      var option = {
        // Setup grid
        grid: {
          left: "1%",
          right: "2%",
          bottom: "3%",
          containLabel: true,
        },
        // Add Tooltip
        tooltip: {
          trigger: "axis",
        },

        legend: {
          data: ["Respuestas"],
        },
        toolbox: {
          show: false,
          feature: {
            restore: { show: false },
            saveAsImage: { show: false },
          },
        },
        color: ["#2962FF"],
        calculable: true,
        xAxis: [
          {
            type: "category",
            data: respuestas,
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            type: "bar",
            data: datos,
          },
        ],
      };
      // use configuration item and data specified to show chart
      myChart.setOption(option);
      this.Resize_Chart(myChart);
      $(window).on("resize", function () {
        that.Resize_Chart(myChart);
      });
      $(".sidebartoggler").on("click", that.Resize_Chart(myChart));
    },
    Resize_Chart(myChart) {
      setTimeout(function () {
        myChart.resize();
      }, 200);
    },
    Consultar() {
      var that = this;
      this.cargando = true;
      this.$http
        .get("dashboard/encuestas")
        .then((respuesta) => {
          return respuesta.json();
        })
        .then((respuestaJson) => {
          this.encuestas = respuestaJson.encuestas;
          this.encuesta_contestada = respuestaJson.encuesta_contestada;
          if (this.opcion == "graficas" || this.encuesta_contestada == true) {
            console.log("contestada");
            this.opcion = "graficas";
            $(document).ready(function () {
              that.Mostrar_Grafica();
            });
          }
        })
        .catch((error) => {})
        .finally((response) => {
          this.cargando = false;
        });
    },
  },
  computed: {
    listo: function () {
      var contestada = false;
      for (var i = 0; i < this.encuestas.length; i++) {
        if (this.encuestas[i].selected != null) {
          contestada = true;
        }
      }
      return contestada;
    },
    usuario() {
      return this.$store.getters.getUsuario;
    },
  },
  mounted() {
    this.Consultar();
  },
};
</script>

<style>
#chartdiv {
  width: 100%;
  height: 500px;
}
</style>


// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Encuestas/Encuestas.vue